import Navigation from '../../../../components/layout/Navigation';
import Footer from '../../../../components/layout/Footer';
import Hero from '../../../../components/ui/Hero';
import Section from '../../../../components/ui/Section';
import FeatureGrid from '../../../../components/ui/FeatureGrid';
import ProcessTimeline from '../../../../components/ui/ProcessTimeline';
import CTA from '../../../../components/ui/CTA';

export default function PackagingDesignPage() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navigation />
      
      <Hero 
        title={<>Your Product's <span className="bg-gradient-to-r from-orange-400 to-pink-500 bg-clip-text text-transparent">First Conversation</span></>}
        description="We design captivating packaging that tells your brand's story, protects your product, and ensures it shines on any shelf."
        bgImage="/assets/packaging-design-studio.png"
        primaryBtn={{ text: "Design Packaging", link: "/contact", icon: "ri-gift-line" }}
        secondaryBtn={{ text: "Our Process", link: "#process", icon: "ri-settings-line" }}
      />

      <Section>
        <FeatureGrid 
          title="The Art of the Unboxing Experience"
          subtitle="Effective packaging design combines art, psychology, and engineering to capture attention and build trust."
          items={[
            { title: 'Visual Appeal', description: 'Eye-catching design reflecting quality.', icon: 'ri-eye-line', color: 'from-orange-500 to-red-500' },
            { title: 'Clarity', description: 'Clear product benefits and details.', icon: 'ri-information-line', color: 'from-pink-500 to-purple-500' },
            { title: 'Brand Reinforcement', description: 'Consistent messaging integration.', icon: 'ri-shield-star-line', color: 'from-purple-500 to-indigo-500' },
            { title: 'Functionality', description: 'Protection and ease of use.', icon: 'ri-shield-check-line', color: 'from-indigo-500 to-blue-500' },
            { title: 'Shelf Impact', description: 'Making your product pop.', icon: 'ri-store-line', color: 'from-blue-500 to-cyan-500' },
            { title: 'Sustainability', description: 'Eco-friendly materials.', icon: 'ri-leaf-line', color: 'from-green-500 to-emerald-500' }
          ]}
        />
      </Section>

      <Section id="process" className="bg-gray-900">
        <ProcessTimeline 
          title="From Concept to Consumer"
          subtitle="We combine creativity with practicality to create visually stunning, functional packaging."
          steps={[
            { title: 'Discovery', description: 'Understanding product & audience.', icon: 'ri-search-line', color: 'from-orange-500 to-pink-500' },
            { title: 'Concepts', description: 'Visualizing design directions.', icon: 'ri-palette-line', color: 'from-pink-500 to-purple-500' },
            { title: 'Materials', description: 'Selecting optimal structures.', icon: 'ri-building-line', color: 'from-purple-500 to-indigo-500' },
            { title: 'Mockups', description: '3D visualization of designs.', icon: 'ri-image-line', color: 'from-indigo-500 to-blue-500' },
            { title: 'Production', description: 'Print-ready file handover.', icon: 'ri-file-transfer-line', color: 'from-blue-500 to-cyan-500' }
          ]}
        />
      </Section>

      <CTA 
        title={<>Packaging That <span className="text-orange-400">Sells Your Story</span></>}
        description="Partner with Hash Adz to create packaging that not only protects your product but also captivates your customers."
        primaryBtn={{ text: "Start Project", link: "/contact" }}
        secondaryBtn={{ text: "View Portfolio", link: "/work" }}
      />

      <Footer />
    </div>
  );
}